import { fetchAppConfig } from './api';
import { logError } from "../../src/components/logger";

let cachedConfig: any = null;

export const setCachedConfig = (config: any) => {
  cachedConfig = config;
};

export const getCachedConfig = () => cachedConfig;

export const fetchAndCacheAppConfig = async (serviceTypeId: string) => {
  const response = await fetchAppConfig(serviceTypeId);
  const raw = response.config;

  if (!raw) {
    logError("Error fetching app config", new Error("No configuration found"));
    throw new Error("No configuration found");
  }

  const parsedColorScheme =
    typeof raw.color_scheme === "string" ? JSON.parse(raw.color_scheme) : raw.color_scheme;

  const fullConfig = {
    ...raw,
    colorScheme: parsedColorScheme,
  };

  setCachedConfig(fullConfig);
  return fullConfig;
};
